import { ForwardedRef, forwardRef, ReactElement, ReactNode } from 'react';
import { Tag, type TagProps, Box } from '@ff-it/ui';
import type { BlockStatus } from './types';
import { blockStateVariantMap } from './BlockStateTag';

export type BlockStatusTagProps = { status: BlockStatus; children?: ReactNode } & Omit<TagProps, 'icon' | 'children'>;
export const BlockStatusTag = forwardRef(function BlockStatusBadge(
  { status: { state, name }, children, ...tagProps }: BlockStatusTagProps,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement {
  return (
    <Tag {...blockStateVariantMap[state]} ref={ref} {...tagProps} testId="block-status-tag" data-state={state}>
      {/* avoid gap */}
      <Box as="span">
        {state}
        {state !== name && (
          <Box as="span" fontWeight="regular">
            : {name}
          </Box>
        )}
      </Box>
      {children}
    </Tag>
  );
});
